import instance from '../utils/axios';
import Appconfig from '../config/config'
export const fetchNewsList = async (params = {}) => {
    const payload = {
        ...params
    };
    return await instance.post('/api/news/list', payload);
};

export const createNews = async (newsData) => {
    return await instance.post('/api/news/', newsData);
};

export const updateNews = async (newsId, newsData) => {
    return await instance.put(`/api/news/${newsId}`, newsData);
};


export const deleteNews = async (newsId) => {
    return await instance.delete(`/api/news/${newsId}`);
};